import { z } from 'zod';
/**
 * Email validation schema.
 * Trims whitespace and enforces a valid email format.
 */
export const emailSchema = z
    .string()
    .trim()
    .min(1, { message: "L'email è obbligatoria" })
    .email({ message: 'Email non valida' });
/**
 * Password validation schema.
 * Minimum 10 characters, at least one uppercase, one lowercase, and one number
 * (per UC-005 BR-1 / security-patterns.md "Password Policy").
 */
export const passwordSchema = z
    .string()
    .min(10, { message: 'La password deve contenere almeno 10 caratteri' })
    .regex(/[A-Z]/, { message: 'La password deve contenere almeno una lettera maiuscola' })
    .regex(/[a-z]/, { message: 'La password deve contenere almeno una lettera minuscola' })
    .regex(/[0-9]/, { message: 'La password deve contenere almeno un numero' });
//# sourceMappingURL=user.js.map